export const importFromCsv = {
  title: 'Import CSV washing machine part',
  importSuccessfully: 'Import washing machine part successfully!',
  importFailed: 'Import washing machine part failed!',
}
